// extracted by mini-css-extract-plugin
export var box = "_3t-2";
export var checkboxControl = "_3t-0";
export var checkboxRow = "_3t-9";
export var checked = "_3t-3";
export var descriptionSpacer = "_3t-b";
export var disabled = "_3t-4";
export var icon = "_3t-7";
export var input = "_3t-1";
export var labelSpacer = "_3t-a";
export var medium = "_3t-6";
export var small = "_3t-5";
export var text = "_3t-8";